module.exports = __webpack_public_path__ + "img/kovalenko.a351f454.jpg";